import React from "react";

import "./BackGroundAlert.css";
import { GiArchiveResearch } from "react-icons/gi";
const BackGroundAlert = () => {
  return (
    <div className="box-alert-background-lealtad">
      <div className="alert-background-lealtad">
        <div className="box-icon-alert-background-lealtad">
          <GiArchiveResearch className="icon-background-alert-lealtad" />
        </div>
        <div className="box-text-alert-background-lealtad">
          <p className="text-alert-background-lealtad">
            Por favor, espere a que la alerta aparezca para buscar las tablas con la información adquirida.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BackGroundAlert;
